/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaFridge: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="fridge" viewBox="0 0 15 15">
      <path
        d="M4.99535 3.75C4.99535 3.40482 5.27517 3.125 5.62035 3.125H6.87035C7.21553 3.125 7.49535 3.40482 7.49535 3.75C7.49535 4.09518 7.21553 4.375 6.87035 4.375H5.62035C5.27517 4.375 4.99535 4.09518 4.99535 3.75Z"
        fill="#2C3439"
      ></path>
      <path
        d="M6.25 7.42336C6.25 7.07818 5.97018 6.79836 5.625 6.79836C5.27982 6.79836 5 7.07818 5 7.42336V9.92336C5 10.2685 5.27982 10.5484 5.625 10.5484C5.97018 10.5484 6.25 10.2685 6.25 9.92336V7.42336Z"
        fill="#2C3439"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0C3.96447 0 3.125 0.839467 3.125 1.875V12.6327C3.125 13.6683 3.96446 14.5077 5 14.5077H10.3336C11.3692 14.5077 12.2086 13.6683 12.2086 12.6327V1.875C12.2086 0.839467 11.3692 0 10.3336 0H5ZM4.375 1.875C4.375 1.52982 4.65482 1.25 5 1.25H10.3336C10.6788 1.25 10.9586 1.52982 10.9586 1.875V4.92336H4.375V1.875ZM4.375 6.17336V12.6327C4.375 12.9779 4.65482 13.2577 5 13.2577H10.3336C10.6788 13.2577 10.9586 12.9779 10.9586 12.6327V6.17336H4.375Z"
        fill="#2C3439"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaFridge)
